import { render } from "./DefaultJob.vue?vue&type=template&id=0b5bb609"
import script from "./DefaultJob.vue?vue&type=script&lang=js"
export * from "./DefaultJob.vue?vue&type=script&lang=js"

import "./DefaultJob.vue?vue&type=style&index=0&id=0b5bb609&lang=css"

import exportComponent from "/home/runner/work/workix-frontend-vue/workix-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__